// extracted by mini-css-extract-plugin
export default {"container":"ImageText_container__ZI2My","Main":"ImageText_Main__6j24s"};